/**
 * 历史说明（正式编号接口接入前）：小区编号接口字段尚待联调；接口有值时优先读取接口编号，接口缺失时临时补前 4 条 mock 编号。
 * 列表与地图共用同一读取方式，待接口契约确定后统一调整。
 * 当前编号来自 mainList.communityNo；mock 编号逻辑已停用，缺失时不再生成序号。
 */
export function getALQCommunityNumber(row: any, index?: number): string {
  void index;
  const number = row?.communityNo ?? row?.communityNumber;
  if (typeof number !== 'string') return '';
  const label = number.trim();
  return label && label !== '-' ? label : '';
}

/** 前 200 个小区存在正式编号时，地图使用编号 Marker。 */
export function getALQMarkerNumber(row: any, index: number): string {
  return index >= 0 && index < 200 ? getALQCommunityNumber(row) : '';
}
